import { useMemo } from "react";

import { useTeamsListQuery } from "app/pages/sales-intelligence/modules/teams/queries/useTeamsListQuery";
import type { TeamListItem } from "app/pages/sales-intelligence/domain/teams/types/team-list-item";

import type { IndustryTransitionImpactReport } from "../types/impactReport";
import { impactedAssetGroupMap } from "../types/impactReport";

export const useImpactReportTerritoryTeams = (
    report: IndustryTransitionImpactReport,
): ReadonlyMap<number, TeamListItem> => {
    const hasTerritories = useMemo(
        () =>
            (report.sections.find((section) => section.group === impactedAssetGroupMap.territories)?.assets.length ??
                0) > 0,
        [report],
    );

    const { data: teams = [] } = useTeamsListQuery({ enabled: hasTerritories });

    return useMemo(() => new Map(teams.map((team) => [team.teamId, team])), [teams]);
};
